import { render } from "./EditTabletForm.vue?vue&type=template&id=6c37b9ba"
import script from "./EditTabletForm.vue?vue&type=script&lang=js"
export * from "./EditTabletForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__